@import url("https://fonts.googleapis.com/css?family=Material+Icons|Material+Icons+Outlined");
@import "~@uipath/apollo-core/src/scss/base-host.scss";

.portal-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}
i {
  color: inherit;
}

.pt-material-icons {
  font-family: "Material Icons", $font-normal;
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-smoothing: antialiased;
}

.pt-material-icons-outlined {
  font-family: "Material Icons Outlined", $font-normal;
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-smoothing: antialiased;
}
